/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
	StyleSheet,
	Image
} from "react-native";

import Style from "ae-style";
import StyledText from "./StyledText";

import loadingImg from "../Resources/img/loading.gif";

import { useResources } from "@aetonix/hooks";

const styles = StyleSheet.create({
	base: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		justifyContent: "center",
		alignItems: "center",
		zIndex: 3,
		flex: 1,
		backgroundColor: Style.colors.primary,
		opacity: 0.8
	},
	canvas: {
		width: Style.imageSize.small,
		height: Style.imageSize.small,
	},
});

export default function Spinner({ open }){
	const { localize } = useResources();
	const loadingText = localize("loader.loading");

	if(!open) return (
		null
	);

	return (
		<View style={styles.base}>
			<Image resizeMethod="resize" resizeMode="contain" style={styles.canvas} source={loadingImg} />
			<StyledText testID={"spinner"} contrast emphasized>{loadingText}</StyledText>
		</View>
	);
}